import React from 'react';
import { Settings } from '@mui/icons-material';
import OverviewToolbar from '../Common/Layout/OverviewToolbar';
import FtseConfigList from './FtseConfigList';

const FtseConfigWrapper: React.FunctionComponent = () => {
  return (
    <div style={{ width: '100%' }}>
      <OverviewToolbar>
        <Settings style={{ marginRight: '7px' }} />
        FTSE Config
      </OverviewToolbar>
      <div>
        <FtseConfigList />
      </div>
    </div>
  );
};

export default FtseConfigWrapper;
